import { AccountsRepository } from '@/repository/repositories/theoryApi/accounts.repository'
import { ActivitiesRepository } from '@/repository/repositories/theoryApi/activities.repository';
import { TasksRepository } from '@/repository/repositories/theoryApi/tasks.repository';
import { ProjectMembersRepository } from '@/repository/repositories/theoryApi/projectMembers.repository';
import { ProjectsRepository } from '@/repository/repositories/theoryApi/projects.repository';
import { OrganizationsRepository } from '@/repository/repositories/theoryApi/organizations.repository';
import { AuthRepository } from '@/repository/repositories/theoryApi/auth.repository';
import { TaskCommentAttachmentFilesRepository } from '@/repository/repositories/theoryApi/taskCommentAttachmentFiles.repository';
import { MastersRepository } from '@/repository/repositories/theoryApi/masters.repository';
import { NotificationsRepository } from '@/repository/repositories/theoryApi/notifications.repository';
import { DirectoriesRepository } from '@/repository/repositories/theoryApi/directories.repository';
import { FilesRepository } from '@/repository/repositories/theoryApi/files.repository';
import { RepositoryInfoRepository } from '@/repository/repositories/theoryGit/repositoryInfo.repository';
import { BranchesRepository } from '@/repository/repositories/theoryGit/branches.repository';
import { FilesRepository as GitFilesRepository } from '@/repository/repositories/theoryGit/files.repository';
import { LogsRepository } from '@/repository/repositories/theoryGit/logs.repository';
import { TagsRepository } from '@/repository/repositories/theoryGit/tags.repository';

const RepositoryFactory = {
  theoryApi: {
    accountsRepository: () => new AccountsRepository(),
    projectsRepository: () => new ProjectsRepository(),
    projectMembersRepository: () => new ProjectMembersRepository(),
    activitiesRepository: () => new ActivitiesRepository(),
    tasksRepository: () => new TasksRepository(),
    organizationsRepository: () => new OrganizationsRepository(),
    authRepository: () => new AuthRepository(),
    taskCommentAttachmentFilesRepository: () => new TaskCommentAttachmentFilesRepository(),
    mastersRepository: () => new MastersRepository(),
    notificationsRepository: () => new NotificationsRepository(),
    directoriesRepository: () => new DirectoriesRepository(),
    filesRepository: () => new FilesRepository(),
  },
  theoryGit: {
    branchesRepository: () => new BranchesRepository(),
    filesRepository: () => new GitFilesRepository(),
    logsRepository: () => new LogsRepository(),
    repositoryInfoRepository: () => new RepositoryInfoRepository(),
    tagsRepository: () => new TagsRepository(),
  }
} as const;

export { RepositoryFactory }
// Promiseの内部の型を取得する
// export type TypeUnwrap<T> =
//   T extends Promise<infer U> ? U :
//   T extends (...args: Array<any>) => Promise<infer V> ? V :
//   T
